module.exports = "../images/northern-pike-fishing-ontario.jpg?v=6ac652e";